/**
* 基础菜单 商品管理
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>消息列表</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<!-- 	<el-form-item label="搜索：">
				<el-input size="small" v-model="formInline.varName" placeholder="输入渠道ID"></el-input>
			</el-form-item> -->
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="messageId" label="消息ID">
			</el-table-column>
			<el-table-column prop="updateTime" label=" 创建时间">
				<template slot-scope="scope">
					<div>{{scope.row.updateTime * 1000|timestampToTime}}</div>
				</template>
			</el-table-column>
      <el-table-column prop="data" label="消息内容" width="500">
      </el-table-column>
			<el-table-column prop="messageType" label="消息类型">
				<template slot-scope="scope">
					<div v-if="scope.row.messageType ==1">商家</div>
					<div v-if="scope.row.messageType ==2">分类</div>
					<div v-if="scope.row.messageType ==3">城市</div>
					<div v-if="scope.row.messageType ==4">订单</div>
					<div v-if="scope.row.messageType ==5">品牌</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" min-width="100">
				<template slot-scope="scope">
          <el-button size="mini" @click="handleEdit1(scope.$index, scope.row.messageId)">推送详情</el-button>

					<el-button size="mini" @click="handleEdit(scope.$index, scope.row.messageId)">推送</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
      	element-loading-text="拼命加载中" style="width: 100%;">
      	<el-table-column prop="name" label="渠道名称">
      	</el-table-column>
      	<el-table-column prop="pushTimes" label="次数">
      	</el-table-column>
      	<el-table-column prop="updateTime" label=" 推送时间">
      		<template slot-scope="scope">
      		  <div>{{scope.row.updateTime * 1000|timestampToTime}}</div>
      		</template>
      	</el-table-column>
      	<el-table-column prop="rateSale" label="推送状态">
      		<template slot-scope="scope">
      			<div v-if="scope.row.state ==1">成功</div>
      			<div v-if="scope.row.state ==0">失败</div>
      		</template>
      	</el-table-column>




      	<!--     <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">关闭</el-button>


      </div>
    </el-dialog>
	</div>
</template>

<script>
	import {
		getMessageListPage,
		pushChannelMsg,
    getPushMessageListPage
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {

				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				editFormVisible: false, //控制编辑页面显示与隐藏
				title: '推送详情',
				editForm: {
					deptId: '',
					deptName: '',
					deptNo: '',
					token: localStorage.getItem('logintoken')
				},
				formInline: {
					page: 1,
					limit: 20,
					varLable: '',
					varName: '',
				},
				// 删除部门
				seletedata: {
					ids: '',
					token: localStorage.getItem('logintoken')
				},
				userparm: [], //搜索权限
				listData: [], //用户数据
				listData1: [], //用户数据
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 20,
					total: 10
				}
			}
		},
		// 注册组件
		components: {
			Pagination
		},

		created() {
			this.getdata(this.formInline)
		},
		methods: {
			// 获取公司列表
			getdata(parameter) {
				this.loading = true
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"page": parameter.page,
					"pageSize": parameter.limit,
					"channelId": parameter.varName
				}
				getMessageListPage(pro)
					.then(res => {
						this.loading = false
						if (res.code == 0) {
							this.listData = res.data.list
							// 分页赋值
							this.pageparm.currentPage = res.data.pageNum
							this.pageparm.pageSize = res.data.pageSize
							this.pageparm.total = res.data.total

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.page = parm.currentPage
				this.formInline.limit = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
				this.getdata(this.formInline)
			},
      handleEdit1(type, id) {
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"page": 1,
					"pageSize": 10000,
          "messageId":id
				}
				getPushMessageListPage(pro)
					.then(res => {
						if (res.code == 0) {
              this.editFormVisible = true
							this.listData1 = res.data.list


						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
      closeDialog() {
        this.editFormVisible = false
        this.listData1 = []
      },
			handleEdit(type, id) {
				this.$confirm('确定要推送吗?', '信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.pushChannelMsg(type, id)
				})
			},
			pushChannelMsg(type, id) {
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"messageId": id
				}
				pushChannelMsg(pro)
					.then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '推送成功'
							})
							this.getdata(this.formInline)
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			}
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/information/informationlist.vue